import Image from "next/image";
import Link from "next/link";

import PropTypes from "prop-types";

import { WriteReview } from "@/components/actions";

export const Items = (props) => {
  const {
    product_name,
    product_image,
    price,
    discount_price,
    total,
    quantity,
    product_slug,
    canReview,
  } = props;

  return (
    <>
      <div className="flex p-4 md:items-center md:justify-between lg:mx-6">
        <div className="mr-2 block w-[5rem] md:hidden">
          <Link href={`/product/${product_slug}`}>
            <Image
              width={60}
              height={60}
              alt={product_name}
              src={product_image}
            />
          </Link>
        </div>

        <div className="w-full md:flex md:items-center md:justify-between">
          <div className="flex items-center">
            <div className="hidden max-w-[5rem] md:mr-4 md:block">
              <Link href={`/product/${product_slug}`}>
                <Image
                  width={60}
                  height={60}
                  alt={product_name}
                  src={product_image}
                />
              </Link>
            </div>
            <div className="md:w-[12rem] lg:w-[10rem] xl:w-[17rem]">
              <Link
                href={`/product/${product_slug}`}
                className="line-clamp-2 inline-block"
              >
                {product_name}
              </Link>
            </div>
          </div>

          <p className="hidden font-semibold md:block">
            ৳{discount_price > 0 ? discount_price : price}
          </p>
          <p className="hidden md:block">
            Qty <span className="font-semibold ">{quantity}</span>
          </p>
          <p className="hidden font-semibold md:block">৳{total}</p>

          <div className="flex flex-row justify-between gap-1 py-3 md:hidden">
            <p className="font-semibold">
              ৳{discount_price > 0 ? discount_price : price}
            </p>
            <p>
              Qty <span className="font-semibold">{quantity}</span>
            </p>
            <p className="font-semibold">৳{total}</p>
          </div>

          {canReview && <WriteReview {...props} />}
        </div>
      </div>
    </>
  );
};

Items.propTypes = {
  product_image: PropTypes.string,
  product_name: PropTypes.string,
  quantity: PropTypes.number,
  price: PropTypes.number,
  discount_price: PropTypes.number,
  has_discount: PropTypes.bool,
  total: PropTypes.number,
  product_slug: PropTypes.string,
  canReview: PropTypes.bool,
};
